import { render } from "./Motors.vue?vue&type=template&id=18715001&scoped=true"
import script from "./Motors.vue?vue&type=script&lang=js"
export * from "./Motors.vue?vue&type=script&lang=js"

import "./Motors.vue?vue&type=style&index=0&id=18715001&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18715001"]])

export default __exports__